import { estQcmSimple } from './questionUtils';

/**
 * Compatibilité mode de passation → format d'exercice. Module pur, sans
 * React : la règle vit ici et nulle part ailleurs (chantier composition,
 * 2026-09-02). Le mode se choisit toujours À LA FIN (boutons de la barre du
 * bas) ; ce module sert à INFORMER pendant la composition (icônes de
 * compatibilité) et à ADAPTER automatiquement la sélection au lancement en
 * cartes (remplacement par un QCM, mise de côté).
 *
 *   - aruco    : en classe avec les cartes → QCM à réponse unique seulement
 *                (règle partagée estQcmSimple, celle du LaunchModal) ;
 *   - en_ligne : tout format ;
 *   - papier   : tout ce que l'impression sait rendre (liste d'exclusion
 *                explicite, vide aujourd'hui).
 */

/** Ordre d'affichage des icônes. Constantes hissées (jamais recréées). */
export const MODES = [
    { id: 'aruco', label: 'en classe avec les cartes' },
    { id: 'en_ligne', label: 'en ligne' },
    { id: 'papier', label: 'sur papier' },
];

/** Formats (type ou subType de payload) que l'impression ne rend pas. */
const EXCLUS_PAPIER = new Set([]);

/** Une clé de format de carte d'exerciseur est-elle un QCM à réponse unique ? */
export const estCleQcmUnique = (format) =>
    Boolean(format) && (/qcm_unique$/.test(format.key || '') || format.label === 'QCM');

/** Un payload (question de banque ou exercice généré) est-il jouable dans ce mode ? */
export const formatJouable = (mode, payload) => {
    if (!payload) return false;
    if (mode === 'aruco') return estQcmSimple(payload);
    if (mode === 'papier') return !EXCLUS_PAPIER.has(payload.type) && !EXCLUS_PAPIER.has(payload?.contenu?.subType);
    return true;
};

/** Un FORMAT de carte ({ key, label } de CATEGORIES.formatsList), AVANT
 *  génération, est-il jouable dans ce mode ? */
export const formatCleJouable = (mode, format) => {
    if (!format) return false;
    if (mode === 'aruco') return estCleQcmUnique(format);
    return true;
};

/** Modes où un payload se joue (pour les icônes de compatibilité). */
export const modesJouablesPayload = (payload) => MODES.filter((m) => formatJouable(m.id, payload)).map((m) => m.id);

/** Modes où un format de carte se joue (idem, avant génération). */
export const modesJouablesFormat = (format) => MODES.filter((m) => formatCleJouable(m.id, format)).map((m) => m.id);
